/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { prospects_ProspectChildResponse } from './prospects_ProspectChildResponse';
import type { prospects_ProspectOwnerResponse } from './prospects_ProspectOwnerResponse';
import type { prospects_ProspectTourResponse } from './prospects_ProspectTourResponse';
export type prospects_ProspectResponse = {
    active_tour?: prospects_ProspectTourResponse;
    archived_at?: string;
    archived_reason?: string;
    archived_reason_code?: string;
    availability_checked?: boolean;
    availability_checked_at?: string;
    availability_checked_by?: string;
    /**
     * Child is DERIVED on read by the LEFT JOIN children plus one EXISTS, and is
     * populated on the DETAIL path ONLY -- the list would pay a join per row.
     * Omitted for an unconverted prospect and on every list row.
     */
    child?: prospects_ProspectChildResponse;
    /**
     * ChildAgeAtStartMonths is the same derivation against desired_start_date.
     */
    child_age_at_start_months?: number;
    /**
     * ChildAgeTodayMonths is derived on read, never stored. It is SIGNED: a
     * pregnancy lead whose date of birth lies in the future yields a negative
     * month count.
     */
    child_age_today_months?: number;
    child_date_of_birth?: string;
    child_dob_is_estimated?: boolean;
    child_first_name?: string;
    /**
     * ChildID IS a column (prospects.child_id, issue #1488): the child this
     * enquiry became. Omitted entirely for an unconverted prospect, so the
     * generated TS type is `child_id?: string | undefined`, NOT `null`.
     */
    child_id?: string;
    child_last_name?: string;
    child_notes?: string;
    /**
     * CloseProbability is DERIVED by query from the newest COMPLETED prospect_tours
     * row. prospects has NO close_probability column and must never get one: a
     * denormalised copy drifts from the tour rows the moment a write path forgets
     * to update it. Omitted when no tour has been completed.
     */
    close_probability?: number;
    created_at: string;
    desired_care_days_per_week?: number;
    desired_care_weekdays?: Array<number>;
    desired_childcare_ids: Array<string>;
    desired_start_date?: string;
    first_contact_channel: string;
    /**
     * FollowupState is the traffic light, derived on read in the ORGANISATION's
     * timezone: ok (green), due_today (amber) or overdue (red).
     */
    followup_state: string;
    id: string;
    /**
     * LanguageCorrespondence IS a column: the family's language as the website
     * intake submitted it. It carries all six codes the intake accepts, not the
     * two the contact form offers.
     *
     * It is READ-ONLY on this surface -- neither request DTO declares it, because
     * the column is written by the intake on create and by nothing else. Omitted
     * entirely when unknown, so the generated TS type is
     * `language_correspondence?: string | undefined`, NOT `null`.
     */
    language_correspondence?: prospects_ProspectResponse.language_correspondence;
    /**
     * The last-contact triple is DERIVED by query from the newest non-deleted
     * prospect_communications row. No last_contact_* column exists on prospects: a
     * denormalised copy would drift from the log the moment a write path forgot to
     * update it. All three are omitted for a prospect that has never been contacted.
     */
    last_contact_at?: string;
    last_contact_by?: string;
    last_contact_direction?: string;
    /**
     * NextFollowupDate is date-only and set by a person, never derived.
     */
    next_followup_date?: string;
    owner?: prospects_ProspectOwnerResponse;
    /**
     * OwnerEmployeeID IS a column: the employee responsible for this enquiry, NOT
     * a Clerk user id. Owner is DERIVED on read by a LEFT JOIN employees in the
     * same query.
     *
     * BOTH keys are omitted entirely for an unassigned prospect, so the generated
     * TS type is `owner?: ... | undefined`, NOT `null`; every client consumer
     * normalizes with `prospect.owner ?? null`.
     */
    owner_employee_id?: string;
    parent1_city?: string;
    parent1_email?: string;
    parent1_first_name: string;
    parent1_house_number?: string;
    parent1_last_name: string;
    parent1_phone?: string;
    parent1_street?: string;
    parent1_zip?: string;
    parent2_email?: string;
    parent2_first_name?: string;
    parent2_last_name?: string;
    parent2_phone?: string;
    remarks?: string;
    status: string;
    subsidized: string;
    /**
     * Tours carries every non-deleted tour, scheduled_at DESC, and ActiveTour the
     * single scheduled one. Both are omitempty, so a prospect with no tours sends
     * NO tours key at all and the generated TS type is `tours?: ...[]` --
     * `undefined`, NOT `[]`. Every client consumer normalizes with
     * `prospect.tours ?? []` / `prospect.active_tour ?? null` BEFORE mapping.
     *
     * Tours is populated by the DETAIL read only -- the list would need one tour
     * query per row. ActiveTour is populated by BOTH: the list derives the same
     * scheduled tour in a lateral, so a board card can render its tour hint from a
     * list row (#1461). The two reads return the identical object for the identical
     * tour; neither is a reduced version of the other.
     */
    tours?: Array<prospects_ProspectTourResponse>;
    updated_at?: string;
    urgency?: string;
    version: number;
};
export namespace prospects_ProspectResponse {
    /**
     * LanguageCorrespondence IS a column: the family's language as the website
     * intake submitted it. It carries all six codes the intake accepts, not the
     * two the contact form offers.
     *
     * It is READ-ONLY on this surface -- neither request DTO declares it, because
     * the column is written by the intake on create and by nothing else. Omitted
     * entirely when unknown, so the generated TS type is
     * `language_correspondence?: string | undefined`, NOT `null`.
     */
    export enum language_correspondence {
        DE = 'de',
        EN = 'en',
        ES = 'es',
        FR = 'fr',
        IT = 'it',
        PT = 'pt',
    }
}

